module.exports = __webpack_public_path__ + "img/gravier_rose.96060b5c.jpg";